<template>
  <b-modal ref="modal" :title="title" hide-footer @hidden="onHidden">
    <b-form-group>
      <label class="font-weight-bold"
        >Tên nhóm <span class="text-danger">*</span></label
      >
      <b-form-input
        ref="nameInput"
        size="sm"
        v-model="form.name"
        maxlength="255"
        placeholder="Ví dụ: Khuyến mãi Tết 2027"
        :state="nameState"
        v-on:keyup.enter="onSave"
      ></b-form-input>
      <b-form-invalid-feedback>{{ nameError }}</b-form-invalid-feedback>
      <b-form-text>
        Bắt buộc, tối đa 255 ký tự. So trùng bỏ khoảng trắng thừa và không phân
        biệt hoa thường.
      </b-form-text>
    </b-form-group>

    <b-form-group>
      <label class="font-weight-bold">Mô tả</label>
      <b-form-textarea
        size="sm"
        rows="3"
        v-model="form.description"
        placeholder="Mô tả ngắn để người sau hiểu nhóm dùng cho việc gì"
      ></b-form-textarea>
      <b-form-text>Không bắt buộc.</b-form-text>
    </b-form-group>

    <b-alert v-if="!form.id" show variant="light-primary" class="py-2">
      Nhóm mới luôn được tạo ở trạng thái Mở.
    </b-alert>

    <div class="mt-3">
      <b-button
        size="sm"
        variant="primary"
        class="mr-2"
        :disabled="isSubmitting"
        @click="onSave"
        >Lưu</b-button
      >
      <b-button size="sm" variant="secondary" @click="hide">Hủy</b-button>
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { makeToastFaile, makeToastSuccess, getApiErrorMessage } from '@/utils/common';

export default {
  data() {
    return {
      isSubmitting: false,
      nameState: null,
      nameError: '',
      form: {
        id: null,
        name: '',
        description: '',
        // Dấu phiên bản đọc lúc mở modal, gửi lại khi lưu để BE chặn ghi đè (BR-013)
        updatedAt: null,
      },
    };
  },
  computed: {
    title() {
      return this.form.id ? 'Sửa nhóm voucher' : 'Thêm nhóm voucher';
    },
  },
  methods: {
    /** @param {Object|null} group null = thêm mới */
    show(group = null) {
      this.form = group
        ? {
            id: group.id,
            name: group.name,
            description: group.description,
            updatedAt: group.updatedAt,
          }
        : { id: null, name: '', description: '', updatedAt: null };
      this.nameState = null;
      this.nameError = '';
      this.$refs.modal.show();
      this.$nextTick(() => {
        if (this.$refs.nameInput) {
          this.$refs.nameInput.focus();
        }
      });
    },
    hide() {
      this.$refs.modal.hide();
    },
    onHidden() {
      this.isSubmitting = false;
    },
    async onSave() {
      if (!this.form.name || !this.form.name.trim()) {
        this.nameState = false;
        this.nameError = 'Vui lòng nhập tên nhóm voucher!';
        return;
      }
      this.nameState = null;
      this.isSubmitting = true;
      const payload = {
        id: this.form.id || undefined,
        name: this.form.name.trim(),
        description: this.form.description,
        updatedAt: this.form.updatedAt,
      };
      try {
        const { data } = await ApiService[this.form.id ? 'put' : 'post'](
          'v2/voucher-groups',
          payload,
        );
        makeToastSuccess(data.message);
        this.hide();
        this.$emit('saved', data.data);
      } catch (err) {
        const message = getApiErrorMessage(err);
        // Trùng tên thì báo ngay tại ô nhập, các lỗi khác dùng toast
        if (message && message.includes('đã tồn tại')) {
          this.nameState = false;
          this.nameError = message;
        } else {
          makeToastFaile(message);
        }
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
